var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.00001,
    y: 1.11707,
    width: 17.8824,
    height: 17.8824,
    rx: 8.94118,
    stroke: "white",
    strokeWidth: 0.941176
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4974 7.46756C13.7754 7.77862 13.7754 8.28286 13.4974 8.59377L8.72311 13.9362C8.44511 14.2471 7.99462 14.2471 7.71662 13.9362L5.44385 11.3929C5.16585 11.082 5.16585 10.5778 5.44385 10.2668C5.72171 9.95578 6.17234 9.95578 6.4502 10.2668L8.2198 12.2469L12.491 7.46756C12.7689 7.15665 13.2196 7.15665 13.4974 7.46756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkWhite);
export default __webpack_public_path__ + "static/media/checkmark-white.0e8af7af2e96fb15b8a21a03faeb4426.svg";
export { ForwardRef as ReactComponent };